import FormField from "./FormField";

const TextArea = (props) => {
  return <FormField as="textarea" rows="3" {...props} />;
};

export default TextArea;
